import request from '../utils/request'

// 获取营收统计数据
export function getRevenueStatistics(params) {
  return request({
    url: '/statistics/homePageStatistics',
    method: 'post',
    data: params
  })
}

// 分校区统计（包含所有图表数据）
export function getBranchRevenue(params) {
  return request({
    url: '/statistics/businessRevenueStatistics',
    method: 'post',
    data: params
  })
}

export function getClassEnrollmentStatistics(params) {
  return request({
    url: '/statistics/classEnrollmentStatistics',
    method: 'post',
    data: params
  })
}

// 实收分校区统计
export function getOrgAmountStatistics(params) {
  return request({
    url: '/statistics/orgAmountStatistics',
    method: 'post',
    data: params
  })
}

// 实时班课在班统计
export function getClassStudentCountStatistics(params) {
  return request({
    url: '/statistics/classStudentCountStatistics',
    method: 'post',
    data: params
  })
}

// 实收分类统计
export function getOrderTypeAmountStatistics(params) {
  return request({
    url: '/statistics/orderTypeAmountStatistics',
    method: 'post',
    data: params
  })
}

// 报课学部统计
export function getPeriodAmountStatistics(params) {
  return request({
    url: '/statistics/periodAmountStatistics',
    method: 'post',
    data: params
  })
}

// 报课分类统计
export function getCourseTypeAmountStatistics(params) {
  return request({
    url: '/statistics/courseTypeAmountStatistics',
    method: 'post',
    data: params
  })
}

// 报课季节分类统计
export function getSemesterAmountStatistics(params) {
  return request({
    url: '/statistics/semesterAmountStatistics',
    method: 'post',
    data: params
  })
}

// 报课剩余课时统计
export function getRemainingHoursStatistics(params) {
  return request({
    url: '/statistics/remainingHoursStatistics',
    method: 'post',
    data: params
  })
}

// 报课分校区统计
export function getOrderOrgStatistics(params) {
  return request({
    url: '/statistics/orderOrgStatistics',
    method: 'post',
    data: params
  })
}

// 支付渠道统计
export function getPaymentChannelStatistics(params) {
  return request({
    url: '/statistics/paymentFlowStatistics',
    method: 'post',
    data: params
  })
}
